export default __webpack_public_path__ + "static/media/action-add_darkGray2.61b91813.svg";